// document.addEventListener('crPickupActivated', function (e) {
//   console.log('__ Pickup Activated __ ')
//   var tt = setInterval(function(){hideDelivery();}, 1000);
//   setTimeout(function() { clearInterval(tt); }, 5000);        	

//        console.log('remove pickup parameters')
// 	   var attributes = {};
//        attributes['Delivery Date'] = '';
//        attributes['Delivery Day'] = '';
//        attributes['Delivery Time'] = '';
       
// //       updateCartAttributes(attributes)
       

//         var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: {
//                 attributes: attributes
//             },
//             dataType: 'json',
//             success: function() {
//                 console.log('Updated cart');               
//             },
//             error: function(XMLHttpRequest, textStatus) {
//                 console.log(XMLHttpRequest, textStatus);
//             }
//         };
//         jqCR.ajax(params);

// })

var hideDelivery = function(){
	$('.identixweb-order-delivery').remove()
}